import Clickable from '@carvana/merch-components/Clickable';
import { motion, AnimatePresence } from 'motion/react';
import { useMemo, useState } from 'react';
import { DownCaratIcon } from './DownCarat';
import {
  QuestionAndResponseTitle,
  QuestionAndResponseWrapper,
  Response
} from './FrequentlyAskedQuestions.styles';

const ToggleUp = {
  transform: 'rotate(180deg)',
  transition: 'transform .25s linear'
};

const ToggleDown = {
  transform: 'rotate(0deg)',
  transition: 'transform .25s linear'
};

type OwnProps = {
  answer?: string;
  items?: string[];
  question?: string;
};

function AnswerWithLink() {
  return (
    <li key="temporarily-closed">
      In several states, our Vending Machines are temporarily closed for
      appointments in accordance with state mandates. You can reschedule your
      appointment through your{' '}
      <a
        data-analytics-id="Order Placed Dashboard"
        href="https://www.carvana.com/acquisition/account/signin"
        className="text-blue-2"
        data-testid="order-placed-dashboard"
      >
        Order Placed Dashboard
      </a>
      .
    </li>
  );
}

export default function QuestionAndResponse({
  answer,
  items,
  question
}: OwnProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  function toggleQuestionClicked() {
    setIsOpen(!isOpen);
  }

  const listAnswers = useMemo(
    () =>
      items
        ? [
            ...items.map(item => <li key={item}> {item} </li>),
            <AnswerWithLink key="answer-with-link" />
          ]
        : [],
    [items]
  );

  return (
    <QuestionAndResponseWrapper>
      <QuestionAndResponseTitle>
        <Clickable
          aria-expanded={isOpen}
          data-analytics-id="FAQ Question"
          data-testid="faq-question"
          element="span"
          onClick={toggleQuestionClicked}
        >
          {question}{' '}
          <DownCaratIcon
            aria-hidden="true"
            className="absolute right-0 top-0"
            style={isOpen ? ToggleUp : ToggleDown}
          />
        </Clickable>
      </QuestionAndResponseTitle>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: 'auto' }}
            exit={{ height: 0 }}
            transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }}
            style={{ overflow: 'hidden' }}
          >
            <Response>{answer}</Response>
            {items ? (
              <Response>
                {' '}
                <ul> {listAnswers} </ul>{' '}
              </Response>
            ) : null}
          </motion.div>
        )}
      </AnimatePresence>
    </QuestionAndResponseWrapper>
  );
}
